yTos.utils.namespace('yTos.configuration.requireJSConfig.paths');

// base checkout model

yTos.configuration.requireJSConfig.paths['ytos.checkout'] = 'model.checkout-0.17.0/model.checkout';
// yTos.configuration.requireJSConfig.paths['ytos.checkout'] = '/jsrepo/model.checkout/src/model.checkout';

yTos.configuration.requireJSConfig.paths['checkout.checkoutFormBase'] = 'checkout.checkoutFormBase-0.2.3/checkout.checkoutFormBase';
// yTos.configuration.requireJSConfig.paths['checkout.checkoutFormBase'] = '/jsrepo/checkout.checkoutFormBase/src/checkout.checkoutFormBase';


// checkout type specific

yTos.configuration.requireJSConfig.paths['checkout.onePage'] = 'checkout.onePage-0.4.1/checkout.onePage';
// yTos.configuration.requireJSConfig.paths['checkout.onePage'] = '/jsrepo/checkout.onePage/src/checkout.onePage';

yTos.configuration.requireJSConfig.paths['checkout.paypalexpress'] = 'checkout.paypalexpress-0.1.5/checkout.paypalexpress';
//yTos.configuration.requireJSConfig.paths['checkout.paypalexpress'] = '/jsrepo/checkout.paypalexpress/src/checkout.paypalexpress';
